module.exports = __webpack_public_path__ + "static/media/maintenance-icon.51621c32.svg";